import { Link } from "react-router-dom";
import type { News } from "@/types";

interface NewsListItemProps {
  item: News;
  showSummary?: boolean;
}

export default function NewsListItem({ item, showSummary = true }: NewsListItemProps) {
  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex items-start gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
    >
      <div className="shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-md overflow-hidden bg-background-200">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - 娱乐资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 mb-1 flex-wrap">
          <span className="px-2 py-0.5 rounded-full text-xs font-label font-medium bg-secondary-100 text-secondary-800">
            {item.channel}
          </span>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        {showSummary && (
          <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {item.summary}
          </p>
        )}
      </div>
      <span className="hidden md:flex w-8 h-8 shrink-0 items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors">
        <i className="ri-arrow-right-line text-lg"></i>
      </span>
    </Link>
  );
}